import React, { Component } from 'react';
import { isEmpty, size } from 'lodash';
import { Alert, Box, Button, FormHelperText, Grid, Typography } from '@mui/material';
import Dialog from '../../common/Dialog';
import EquipDemandLineForm from './EquipDemandLineForm';
import { AddCircleOutlineRounded } from '@mui/icons-material';
import InputText from '../../common/Form';
import DatePickerCmp from '../../common/DatePicker';
import axios from 'axios';
import Spinner from '../../common/Spinner';
import { oneWeek } from '../../../utils/statsFunctions';


class EquipDemandsForm extends Component {
    state = { 
        demand_start_date: new Date(new Date().setHours(0, 0, 0, 0)),
        demand_end_date: new Date(new Date().setHours(0, 0, 0, 0)),
        demand_remarks: "",
        demand_equipements: [
            {
                line_equipement: "",
                line_quantity: "",
                line_remarks: "",
                line_equipementDisplay: {value: "", label: ""}
            }
        ],
        errors: [
            {
                line_equipement: "",
                line_quantity: "",
                // line_remarks: ""
            }
        ],
        EQUIPEMENTS: [],
        fetching : true,
    }
    componentDidMount = async () => {
        console.log('===============LOAN_DEMANDS=====================');
        console.log(this.props.demand);
        console.log('====================================');
        const res = await axios.get('/equipements/get/all/available')
        console.log({res});
        if(!res.data.error){
            this.setState({
                EQUIPEMENTS: res.data,
                fetching: false
            })
        } else {
            this.setState({
                // EQUIPEMENTS: res.data,
                fetching: false
            })
        }


        if (!isEmpty(this.props.demand)) {
            let demand_equipements = []
            let errors = []
            Object.values(this.props.demand).map( demand => {
                demand.line_equipementDisplay = {
                    value: demand.line_equipement,
                    label: this.state.EQUIPEMENTS[demand.line_equipement].equipement_original_name,
                }
                demand_equipements.push(demand)
                errors.push({
                    line_equipement: "",
                    line_quantity: "",
                    // line_remarks: ""
                })

            })
            this.setState({
                demand_equipements,
                errors
            })
        }   

    }

    handleAddForm = () => {
        
        this.setState({
            demand_equipements: [
                ...this.state.demand_equipements,
                {
                    // demand_id: "", for updates ?
                    line_equipement: "",
                    line_quantity: "",
                    line_remarks: "",
                    line_equipementDisplay: {value: "", label: ""}
                }
            ],
            
            errors:[
                ...this.state.errors, {
                    line_equipement: "",
                    line_quantity: "",
                    // line_remarks: ""
                }
            ]
            
        })
    }
    createAddForm = () => {
        const { demand_equipements } = this.state
        
        let selected = demand_equipements.map( item => item.line_equipement)
        console.log('====================================');
        console.log({selected});
        console.log('====================================');
        let tab = []
        let total = 0
        // for(let i = 0; i < size(demand_equipements); i++){
            demand_equipements.map((art, i) => {
                total += art.line_quantity
                
                tab.push(
                    <EquipDemandLineForm
                        {...art}
                        EQUIPEMENTS={ this.state.EQUIPEMENTS && this.state.EQUIPEMENTS}
                        selected={selected}
                        errors={this.state.errors[i]} 
                        handleChange={this.handleChangeArticles} 
                        handleChangeCreatable={this.handleChangeCreatable} 
                        deleteLine={this.deleteLine} 
                        index={i} 
                    />
                )
            })
            
        // }
        return {tab, total}
    }

    deleteLine = (index) => {
        this.setState({
            demand_equipements: [
                ...this.state.demand_equipements.slice(0,index),
                ...this.state.demand_equipements.slice(index +1),
            ],
            errors: [
                ...this.state.errors.slice(0,index),
                ...this.state.errors.slice(index +1),
            ]
            ,
        })

    }
    handleChangeArticles = (name, value, index) => {
        console.log('=========== handleChangeArticles ===============');
        console.log({name, value, index});
        
        let cpArticles = [].concat(this.state.demand_equipements)  
        if( name == "line_quantity" && value !== ""){
            cpArticles[index][name] = parseInt(value) 
        } else {
            cpArticles[index][name] = value
        } 

        console.table(cpArticles);

        this.setState({
            ...this.state,
            demand_equipements: cpArticles
        })
    }
    handleChangeCreatable = (option, name, index) => {
        let cpArticles = [].concat(this.state.demand_equipements) 
        let errors = [].concat(this.state.errors)
        if(option){         
            cpArticles[index][name] = option.value
            cpArticles[index].nb_dispo = option.nb_dispo
            cpArticles[index][`${name}Display`] = option
        } else {
            cpArticles[index][name] = ""
            cpArticles[index].nb_dispo = ""
            cpArticles[index][`${name}Display`] = {label: "", value: ""}
        }
        errors[index][name] = "" 
        errors[index].line_quantity = "" 
        this.setState({
            ...this.state,
            demand_equipements: cpArticles,
            errors,
        })
    }
    handleChangeDate = (name, date) => {
        let newDate = date.setHours(0, 0, 0, 0)

        // if((newDate - new Date()) < oneWeek) {
        //     console.log('====================================');
        //     console.log("periode inférieur à 7 jours: ", (newDate - new Date()) / 1000 / 60 / 60 / 24 );
        //     console.log('====================================');
        // } else {
        //     console.log('====================================');
        //     console.log("periode supérieur à 7 jours: ", (newDate - new Date()) / 1000 / 60 / 60 / 24);
        //     console.log('====================================');

        // }
        this.setState({
            [name]: new Date(newDate)
        })
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    validate = () => {
        let demand_equipements = [].concat(this.state.demand_equipements)
        let total = size(demand_equipements)
        let required = [
            "line_quantity",
            "line_equipement",
        ]

        // let errors = []
        let errors = [].concat(this.state.errors)
        let noError = true

        demand_equipements.forEach( (item, index) => {
            required.forEach(field => {
                if( isEmpty(item[field]) && !item[field] ) { 
                    console.log(`${field} is empty`)
                    noError = false
                    errors[index][field] = "Veuillez remplir ce Champ" 
                } else {

                    console.log('====================================');
                    console.log(item, item[field], item.nb_dispo , item[field] > item.nb_dispo );
                    console.log('====================================');
                    // if(field == "line_quantity" && item[field] < 1  ){
                    if(field == "line_quantity" && item[field] > item.nb_dispo  ){
                        errors[index][field] = `Dispo : ${item.nb_dispo}`  // color red
                        noError = false
                    } else {
                        errors[index][field] = "" 
                    }
                }
            })
        })
       console.log('===============in validateArticles=====================');
       console.log({errors});
       console.log('====================================');
        // return {
        //     noError, errors, total
        // }
        this.setState({
            errors: errors,
            noError: noError,
            total: total
        })
        return noError
    }

    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            data.demand_equipements = this.state.demand_equipements
            data.demand_start_date = this.state.demand_start_date
            data.demand_end_date = this.state.demand_end_date
            data.demand_remarks = this.state.demand_remarks

            console.log('====================================');
            console.log("submit demand", {data});
            console.log('====================================');
        
            await this.props.newLoanDemand(data)

            // // if NoErrors ...
            if(this.props.STATE.demands.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.demands.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    validateUpdate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "demand_equipements",
        ]
            
        console.log('====================================');
        console.log({required});
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    handleSubmitUpdate = async () => {

        if( this.validateUpdate() ){
            let data = Object.assign({}, this.props.demand)
            data.demand_equipements = isEmpty(this.state.demand_equipements) ? "" : this.state.demand_equipementsID.join(", ")

            console.log('====================================');
            console.log("submit demand", {data});
            console.log('====================================');
        
            await this.props.updateSession(data)
            
            // // if NoErrors ...
            if(this.props.STATE.demands.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.demands.error}`)
            } else { 
                this.props.notif("success", "la demande a été modifiée")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { EQUIPEMENTS } = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        const { tab, total } = this.createAddForm();
        return (
            <Dialog
                title={`Liste de Demandes`}
                close={this.props.handleClose}
                submitAction={!isEmpty(EQUIPEMENTS) && !isEmpty(tab) && this.handleSubmit}
                appBar
                maxWidth="xl"
            >
                <Grid container >
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <DatePickerCmp  
                                id="demand_start_date" 
                                label="Date d'attribution souhaitée" 
                                name="demand_start_date" 
                                value={this.state.demand_start_date} 
                                handleChange={(option) => this.handleChangeDate("demand_start_date", option)} 
                                error={this.state.errors.demand_start_date}
                                required
                                noPadding
                            />      
                        </Box>
                    </Grid>   
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <DatePickerCmp  
                                id="demand_end_date" 
                                label="Date de retour prévue" 
                                name="demand_end_date" 
                                value={this.state.demand_end_date} 
                                handleChange={(option) => this.handleChangeDate("demand_end_date", option)} 
                                error={this.state.errors.demand_end_date}
                                required
                                noPadding
                            />      
                        </Box>
                    </Grid>   
                    {(this.state.demand_start_date - new Date()) < oneWeek &&
                        <Grid item xs={12} >
                            <Alert severity="info">
                                Pour une meilleure prise en charge, pensez à faire vos demandes au moins 1 semaine en avance
                            </Alert>
                        </Grid>
                    }
                    <Grid item xs={12} >
                        <InputText
                            onChange={this.handleChange}
                            multiline
                            required
                            rows={2}
                            id="demand_remarks"
                            error={this.state.errors.demand_remarks}
                            value={this.state.demand_remarks}
                            name="demand_remarks"
                            label="Usage prévu"
                        />
                    </Grid>
                    {this.state.fetching ?
                        <Spinner />
                    : 
                        <Grid item xs={12}>
                            {!isEmpty(this.state.EQUIPEMENTS) ?
                                tab
                                :
                                <Alert severity="warning">
                                    Aucun equipement disponible
                                </Alert>
                            }
                        </Grid>
                    }
                </Grid>      
                {size(tab) < size(EQUIPEMENTS) &&
                    <Box style={{textAlign: "center"}}>
                        <Button startIcon={<AddCircleOutlineRounded />} variant="contained" onClick={this.handleAddForm} color="secondary">
                            Ajouter un Equipement
                        </Button>
                    </Box>
                }
            </Dialog>
        );
    }
}

export default EquipDemandsForm;